"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var StreamMetricReport = /** @class */ (function () {
    function StreamMetricReport() {
        this.previousMetrics = {};
        this.currentMetrics = {};
    }
    return StreamMetricReport;
}());
exports.default = StreamMetricReport;
//# sourceMappingURL=StreamMetricReport.js.map